import CustomerVehiclesHtml from './customer.vehicles.html';

export function CustomerVehiclesDirective () {
  return {
    controller: 'CustomerVehiclesCtrl',
    restrict: 'E',
    templateUrl: CustomerVehiclesHtml,
    scope: {
      customer: '=',
      vehicles: '='
    }
  }
}
